import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  TextField,
  Button,
  Paper,
  InputAdornment,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const GoogleMapsLikeSearchOverlay = ({ searchResults, onSearchResultClick,searchQuery,setSearchQuery,loading,setLoading }) => {
  const [inputQuery, setInputQuery] = useState('');
  const [showResults, setShowResults] = useState(false); // Controls visibility of search results

  const handleSearch = () => {
    setShowResults(true); // Show search results when a search is performed
    setSearchQuery(inputQuery);
    setLoading(true);
    // You can also trigger an API call or filter here for search results
  };

  const handleClear = () => {
    setInputQuery(''); // Clear the search input
    setShowResults(false); // Optionally hide results when cleared
    setSearchQuery('');
  };
  const handleKeyDown = (event) => {
    debugger;
    if (event.key === 'Enter') {
        handleSearch();
    }
  };

  return (
    <>
      {/* Search Box Overlay */}
      <Paper
        sx={{
          position: 'absolute',
          top: 20,
          right: 20,
          zIndex: 1000,
          padding: 2,
          width: 300, // Similar width to Google Maps search box
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          backgroundColor: 'white', // Ensure it's always visible on top of the map
        }}
      >
        {/* Search Input */}
        <TextField
          variant="outlined"
          label="Search"
          fullWidth
          value={inputQuery}
          onKeyDown={handleKeyDown}  // This will capture Enter key press
         placeholder="Type something and press Enter"
          onChange={(e) => {
            setInputQuery(e.target.value)

          }}
          sx={{ marginBottom: '10px' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: inputQuery && (
              <InputAdornment position="end">
                <IconButton onClick={handleClear}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {/* <Button
          variant="contained"
          fullWidth
          onClick={handleSearch} // Trigger the search action
          disabled={!inputQuery} // Disable search button if input is empty
        >
          Search
        </Button> */}
      </Paper>

      {/* Search Results Overlay */}
      {showResults && searchResults.length > 0 && (
        <Paper
          sx={{
            position: 'absolute',
            top: 100, // Appear just below the search box
            right: 20,
            zIndex: 1000,
            padding: 2,
            width: 300,
            maxHeight: '400px',
            overflowY: 'auto', // Scrollable if results exceed max height
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'white',
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 2 }}>
            Search Results
          </Typography>
          <List>
            {searchResults.map((result, index) => (
              <React.Fragment key={index}>
                <ListItem button onClick={() => onSearchResultClick(result.OBJECTID)}>
                  <ListItemText
                    primary={result.Name}
                    secondary={`DOB: ${result.DOB}, DOD: ${result.DOD}`}
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      )}
    </>
  );
};

export default GoogleMapsLikeSearchOverlay;
